import { createSlice } from "@reduxjs/toolkit"

const slice = createSlice({
  name: "chat",
  initialState: {
    list: [],
    loading: true,
    error: false,
    refresh: true,
  },
  reducers: {
    setList: (state, action) => {
      state.list = action.payload
    },
    setLoading: (state, action) => {
      state.loading = action.payload
    },
    setError: (state, action) => {
      state.error = action.payload
    },
    setRefresh: (state, action) => {
      state.refresh = action.payload
    },
  },
})

export const { setList, setLoading, setError, setRefresh } = slice.actions

export default slice.reducer
